<script setup lang='ts'>
import type { NuxtLinkProps } from '#app'
import type { CardProps } from '~/utils/card'
import { NuxtLink } from '#components'
import { twMerge } from 'tailwind-merge'

const props = defineProps<NuxtLinkProps & CardProps>()

const { class: attrClass, ...restAttrs } = useAttrs()
</script>

<template>
  <component
    :is="(href || to) ? NuxtLink : 'div'"
    :class="twMerge(cardVariants.card.base({ type, size, presentation, orientation }), String(attrClass || ''))"
    v-bind="{ ...props, ...restAttrs }"
  >
    <slot name="header" />
    <slot />
  </component>
</template>
